export function getMonth(time) {
    let month = new Date(time).getMonth() + 1
    if (month < 10) {
        return '0' + month
    }
    return month
}

export function getDay(time) {
    let day = new Date(time).getDate()
    if (day < 10) {
        return '0' + day
    }
    return day
}

export function getYear(time) {
    let year = new Date(time).getFullYear()
    return year
}

export function getTel(tel) {
    var reg = /^(\d{3})\d{4}(\d{4})$/;
    return tel.replace(reg, "$1****$2");
}

export function renderSize(value) {
    if (null == value || value == '') {
        return "0 Bytes";
    }
    var unitArr = new Array("Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB");
    var index = 0;
    var srcsize = parseFloat(value);
    index = Math.floor(Math.log(srcsize) / Math.log(1024));
    var size = srcsize / Math.pow(1024, index);
    size = size.toFixed(2); //保留的小数位数
    return size + unitArr[index];
}


// WEBPACK FOOTER //
// ./src/utils/index.js